export default __webpack_public_path__ + "static/media/friendly01.02003cb1.png";